import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import Yup from '../../../services/common/validation';
import { LinkedRelationshipFormModel_MX } from './formModel';
import { getEnumValues } from '../../../services/common/miscUtils';
import { NoYesEnum } from '../../../types/forms';

export const getValidationSchema = (): ObjectSchema<LinkedRelationshipFormModel_MX> => {
  return Yup.object({
    majorityInCompanies: Yup.string().requiredWithMsg().oneOf(getEnumValues(NoYesEnum)),
    majorityInCompaniesCompanyName: Yup.string().when('majorityInCompanies', {
      is: (majorityInCompanies: string) => majorityInCompanies === 'yes',
      then: (schema) => schema.requiredWithMsg().max(255, t('validation:maxLength', { value: 255 })),
      otherwise: (schema) => schema.notRequired(),
    }),
    partnerOfCompanies: Yup.string().requiredWithMsg().oneOf(getEnumValues(NoYesEnum)),
    partnerOfCompaniesCompanyName: Yup.string().when('partnerOfCompanies', {
      is: (partnerOfCompanies: string) => partnerOfCompanies === 'yes',
      then: (schema) => schema.requiredWithMsg().max(255, t('validation:maxLength', { value: 255 })),
      otherwise: (schema) => schema.notRequired(),
    }),
    customerOfVwfs: Yup.string().requiredWithMsg().oneOf(getEnumValues(NoYesEnum)),
    contactNumberOrVehicleRegistrationNumber: Yup.string().when('customerOfVwfs', {
      is: (customerOfVwfs: string) => customerOfVwfs === 'yes',
      then: (schema) =>
        schema
          .requiredWithMsg()
          .max(255, t('validation:maxLength', { value: 255 }))
          .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers')),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
};
